import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Field,
  FieldArray,
  reduxForm,
  stopSubmit,
  formValueSelector,
  getFormValues,
} from "redux-form";
import {
  Form,
  FormGroup,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import StarRating from "../../system/fields/StarRating";
import Switch from "../../system/fields/Switch";
import { getOverview } from "../../store/overview";

import * as validations from "../../system/utils/Validation";
import Wysiwyg from "../../system/fields/Wysiwyg";

import ReviewsTable from "./components/ReviewsTable";
import Activites from "./components/Activites";
import Faq from "./components/Faq";

let EditForm = (props) => {
  const { 
    dispatch,
    handleSubmit, 
    formValues,
    destinationCategories, 
    initialValues, 
    reviews, 
    sub_title
  } = props;
  const { name } = initialValues || {};
  const [activeTab, setActiveTab] = useState(1);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }

  useEffect(() => {
    dispatch(getOverview())
  }, [])
    
    return (
      <section className='edit-form'>
        <Form onSubmit={handleSubmit}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={activeTab === 1 ? "active" : ""}
                onClick={() => {
                  toggleTab(1);
                }}
              >
                Sub Category Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === 2 ? "active" : ""}
                onClick={() => {
                  toggleTab(2);
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === 3 ? "active" : ""}
                onClick={() => {
                  toggleTab(3);
                }}
              >
                Activities
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={activeTab === 3 ? "active" : ""}
                onClick={() => {
                  toggleTab(4);
                }}
              >
                F&Q's
              </NavLink>
            </NavItem>
          </Nav>

          <section className='form-section'>
             <TabContent activeTab={activeTab}>
              <TabPane tabId={1}>
                <div className='row'>
              <FormGroup className='col-12 col-sm-6'>
                <Label>Parent Category</Label>
                <Field
                  name='parent'
                  component={SelectDropdown}
                  labelKey='name'
                  valueKey='id'
                  options={destinationCategories}
                  validate={validations.required}
                  autoFocus={true}
                />
              </FormGroup>
            </div>

            <div className='row'>
              <FormGroup className='col-12'>
                <Label htmlFor='email'>Name</Label>
                <Field
                  name='name'
                  component={TextInput}
                  defaultValue={name && name || ''}
                  placeholder='Category Name'
                  type='text'
                  validate={validations.required}
                  autoFocus={true}
                />
              </FormGroup>
            </div>

            <div className='row'>
              <FormGroup className='col-12'>
                <Label htmlFor='email'>Sub Title</Label>
                <Field
                  name='sub_title'
                  component={TextInput}
                  defaultValue={sub_title && sub_title || ''}
                  placeholder='Sub Title'
                  type='text'
                  validate={validations.required}
                  autoFocus={true}
                />
              </FormGroup>
            </div>

            {/* <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Title</Label>
              <Field
                name="title"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div> */}
            <div className='row'>
              <FormGroup className='col-12'>
                  <Label htmlFor='email'>Summary</Label>
                  <Field name='summary' component={Wysiwyg} type='text' />
              </FormGroup>
            </div>
            <div className='row'>
              <FormGroup className='col-12'>
               <Label htmlFor='email'>Description</Label>
                <Field
                  name='description'
                  component={Wysiwyg}
                  type='text'
                  validate={validations.required}
                />
              </FormGroup>
            </div>

            {/* 
          <div className="row">
            <FormGroup className="col-12">
              <Label htmlFor="email">Summary</Label>
              <Field
                name="summary"
                component={Wysiwyg}
                type="text"
                validate={validations.required}
              />
            </FormGroup>
          </div> */}

            <div className='row'>
              <FormGroup className='col-12'>
                <Label htmlFor='email'>Banner Image</Label>
                <Field
                  name='banner_image'
                  component={FileUpload}
                  multiple={false}
                  files={false}
                  images={true}
                  type='text'
                  className='form-control'
                  validate={validations.required}
                />
              </FormGroup>
            </div>
                
              </TabPane>
              <TabPane tabId={2}>
                <ReviewsTable
                  data={reviews}
                  dispatch={dispatch}
                  formValues={formValues}
                  initialValues={initialValues}
                  formType='SubCategoryForm'
                />
              </TabPane>
              <TabPane tabId={3}>
                <FieldArray name={"activities"} component={Activites} />
              </TabPane>
              <TabPane tabId={4}>
                <FieldArray name={"faqs"} component={Faq} />
              </TabPane>
            </TabContent>
            
          </section>
        </Form>

        {props.submitFailed && (
          <div className='error-container'>
            <Alert color='danger'>
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }

EditForm = reduxForm({
  form: "SubCategoryForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("SubCategoryForm"));
    }
  },
})(EditForm);

const selector = formValueSelector("SubCategoryForm");

const mapStateToProps = (state) => {
  return {
    dealTypes: state.overview.dealTypes,
    destinationCategories: state.overview.destinationCategories,
    dealStatuses: state.overview.dealStatuses,
    reviews: state.overview.reviews,
    day_dates: selector(state, "day_dates"),
    formValues: getFormValues("SubCategoryForm")(state),
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/SubCategories/Form.jsx